namespace RioERP.Carts {
    export interface FranchiseeProductsForm {
        ProductName: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        SkuCode: Serenity.StringEditor;
        EProductType: Serenity.IntegerEditor;
        ProductCategList: Serenity.LookupEditor;
        ERioplayVersion: Serenity.IntegerEditor;
        RioplayProductCode: Serenity.StringEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        HasPenDrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        Note: Serenity.StringEditor;
        Weight: Serenity.DecimalEditor;
        Height: Serenity.DecimalEditor;
        Width: Serenity.DecimalEditor;
        Length: Serenity.DecimalEditor;
        EPackingType: Serenity.IntegerEditor;
        GrossAmount: Serenity.DecimalEditor;
        EOpens: Serenity.IntegerEditor;
        EWatchTime: Serenity.IntegerEditor;
        EValidity: Serenity.IntegerEditor;
        EValidityType: Serenity.IntegerEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowSerialKeyGeneration: Serenity.BooleanEditor;
        AllowedDevices: Serenity.StringEditor;
        ProcesOrderOnPaid: Serenity.BooleanEditor;
        EAccessStatus: Serenity.IntegerEditor;
        InAppDownload: Serenity.BooleanEditor;
        HasVod: Serenity.BooleanEditor;
        SupportInfo: Serenity.StringEditor;
        ProductQueryInfo: Serenity.StringEditor;
        EShippedby: Serenity.IntegerEditor;
        ActivateSerialKey: Serenity.BooleanEditor;
        IsCombo: Serenity.BooleanEditor;
        ProductIds: Serenity.StringEditor;
        WebsiteUrl: Serenity.StringEditor;
        TeacherName: Serenity.StringEditor;
        Thumbnail: Serenity.StringEditor;
    }

    export class FranchiseeProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.FranchiseeProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeProductsForm.init)  {
                FranchiseeProductsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.BooleanEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.DateEditor;

                Q.initFormType(FranchiseeProductsForm, [
                    'ProductName', w0,
                    'Description', w1,
                    'SkuCode', w0,
                    'EProductType', w2,
                    'ProductCategList', w3,
                    'ERioplayVersion', w2,
                    'RioplayProductCode', w0,
                    'DownloadUrl1', w0,
                    'DownloadUrl2', w0,
                    'HasPenDrive', w4,
                    'HasBooks', w4,
                    'HasCourier', w4,
                    'Note', w0,
                    'Weight', w5,
                    'Height', w5,
                    'Width', w5,
                    'Length', w5,
                    'EPackingType', w2,
                    'GrossAmount', w5,
                    'EOpens', w2,
                    'EWatchTime', w2,
                    'EValidity', w2,
                    'EValidityType', w2,
                    'ValidTill', w6,
                    'TotalAllowedDuration', w2,
                    'AllowSerialKeyGeneration', w4,
                    'AllowedDevices', w0,
                    'ProcesOrderOnPaid', w4,
                    'EAccessStatus', w2,
                    'InAppDownload', w4,
                    'HasVod', w4,
                    'SupportInfo', w0,
                    'ProductQueryInfo', w0,
                    'EShippedby', w2,
                    'ActivateSerialKey', w4,
                    'IsCombo', w4,
                    'ProductIds', w0,
                    'WebsiteUrl', w0,
                    'TeacherName', w0,
                    'Thumbnail', w0
                ]);
            }
        }
    }
}
